import { useLayoutEffect, useRef, useState } from 'react'
import { Badge, Group, Box } from '@mantine/core'

// スキルタグを最大2行に収め、はみ出した分は「+N」で示す。
// 実際に描画してからチップの offsetTop で行を判定する(幅が変わればResizeObserverで再計算)。
// 案件カード(#1080)と人材カード(#1192)で共用する。
export const CHIP_HEIGHT = 20 // Badge size="sm" の高さ
export const CHIP_GAP = 6
export const MAX_ROWS = 2
export const CHIPS_BOX_HEIGHT = CHIP_HEIGHT * MAX_ROWS + CHIP_GAP * (MAX_ROWS - 1)

export default function SkillChips({ skills, mb = 'sm' }) {
  const measureRef = useRef(null)
  const [visibleCount, setVisibleCount] = useState(skills.length)

  useLayoutEffect(() => {
    const el = measureRef.current
    if (!el) return undefined

    const compute = () => {
      const chips = Array.from(el.children)
      if (chips.length === 0) return
      const firstTop = chips[0].offsetTop
      const limitTop = firstTop + CHIP_HEIGHT * (MAX_ROWS - 1) + CHIP_GAP * (MAX_ROWS - 1) + 1
      let fit = chips.filter((c) => c.offsetTop <= limitTop).length
      // はみ出しがある時は「+N」チップの分だけ1つ減らして場所を空ける
      if (fit < chips.length && fit > 0) fit -= 1
      setVisibleCount(fit)
    }

    compute()
    const ro = new ResizeObserver(compute)
    ro.observe(el)
    return () => ro.disconnect()
  }, [skills])

  const hidden = skills.length - visibleCount

  return (
    <Box style={{ position: 'relative', height: CHIPS_BOX_HEIGHT, overflow: 'hidden' }} mb={mb}>
      {/* 計測用: 全チップを同じ幅で不可視描画 */}
      <Group
        ref={measureRef}
        gap={CHIP_GAP}
        aria-hidden="true"
        style={{ position: 'absolute', inset: 0, visibility: 'hidden', pointerEvents: 'none', alignItems: 'flex-start' }}
      >
        {skills.map((s) => (
          <Badge key={s} variant="outline" color="brand" size="sm">{s}</Badge>
        ))}
      </Group>

      <Group gap={CHIP_GAP} style={{ alignItems: 'flex-start' }}>
        {skills.slice(0, visibleCount).map((s) => (
          <Badge key={s} variant="outline" color="brand" size="sm">{s}</Badge>
        ))}
        {hidden > 0 && (
          <Badge variant="light" color="gray" size="sm" title={skills.slice(visibleCount).join('、')}>
            +{hidden}
          </Badge>
        )}
      </Group>
    </Box>
  )
}
